import { getLocales } from 'assets/locales/Locale';
import Theme from 'assets/themes/Theme.Common';

type ContractRefundStatusProps = {
  statusCode: Model.Enum.ContractRefundStatusCode;
};
export default function ContractRefundStatus({ statusCode }: ContractRefundStatusProps) {
  const { translate } = getLocales();
  return (
    <span
      style={
        statusCode === 'CANCELLED'
          ? { color: Theme.Color.error, fontWeight: 'bold' }
          : statusCode === 'PAID'
            ? { color: Theme.Color.success, fontWeight: 'bold' }
            : undefined
      }
    >
      {translate(statusCode)}
    </span>
  );
}
